<template>
  <div class="treasure-container">
    <transition name="slide-down">
      <div v-show="treasureVisible[0]" class="treasure-01">
          <img src="../assets/treasure/treasure01.png" alt="">
      </div>
    </transition>
    <transition name="slide-down">
      <div v-show="treasureVisible[1]" class="treasure-02">
          <img src="../assets/treasure/treasure02.png" alt="">
      </div>
    </transition>
    <transition name="slide-down">
      <div v-show="treasureVisible[2]" class="treasure-03">
          <img src="../assets/treasure/treasure03.png" alt="">
      </div>
    </transition>
    <transition name="slide-down">
      <div v-show="treasureVisible[3]" class="treasure-04">
          <img src="../assets/treasure/treasure04.png" alt="">
      </div>
    </transition>
    <transition name="slide-down">
      <div v-show="treasureVisible[4]" class="treasure-05">
          <img src="../assets/treasure/treasure05.png" alt="">
      </div>
    </transition>
    <transition name="slide-down">
      <div v-show="treasureVisible[5]" class="treasure-06">
          <img src="../assets/treasure/treasure06.png" alt="">
      </div>
    </transition>
    <transition name="slide-down">
      <div v-show="treasureVisible[6]" class="treasure-07">
          <img src="../assets/treasure/treasure07.png" alt="">
      </div>
    </transition>

        <div class="right_arrow">
            <!-- <img src="../assets/treasure/rightarrow.png" alt=""> -->
    </div>
    
  </div>
</template>

<script setup>
// @ is an alias to /src
import { useRouter } from 'vue-router'
import { ref, onMounted } from 'vue'

const router = useRouter()

// 控制每个宝藏元素的显示状态
const treasureVisible = ref([false, false, false, false, false, false, false])

const GotoChooseListView = async () => {
  // 尝试播放音乐
  if (window.playBgMusic && typeof window.playBgMusic === 'function') {
    await window.playBgMusic()
  }
  
  // 跳转到导航页面
  router.push({
    path: '/choose',
  })
}

// 实现依次弹入动画
const startAnimationSequence = () => {
  // 依次显示每个宝藏元素，间隔300毫秒
  treasureVisible.value.forEach((_, index) => {
    setTimeout(() => {
      treasureVisible.value[index] = true
      
      // 如果是最后一个元素，则在动画完成后跳转
      if (index === treasureVisible.value.length - 1) {
        setTimeout(() => {
          GotoChooseListView()
        }, 2500) // 等待最后一个元素动画完成
      }
    }, index * 300) // 每个元素延迟300ms
  })
}

onMounted(() => {
  // 组件挂载后开始动画序列
  startAnimationSequence()
})


</script>

<style lang="scss" scoped>
.treasure-container {
  background-image: url('../assets/treasure/treasure_bg.jpg');
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  justify-content: flex-start;
  align-items: left;
  position: relative; /* 容器相对定位，作为绝对定位子元素的参考 */
  @media screen and (min-width: 1024px){
    overflow: hidden;
  }
}

.treasure-01{
  /* 设置背景图 */
  position: absolute;
  width: 55px;
  height: 284px;
  top: 226px;
  left: 36px;
  img{
    width: 100%;
    height: 100%;
  }

}

.treasure-02{
    position: absolute;
  width: 55px;
  height: 463px;
  top: 354px;
  left: 260px;
  img{
    width: 100%;
    height: 100%;
  }

}
.treasure-03{
position: absolute;
  /* 设置背景图 */
  width: 55px;
  height: 412px;
  top: 129px;
  left: 432px;
  img{
    width: 100%;
    height: 100%;
  }
} 

.treasure-04{
  /* 设置背景图 */
  position: absolute;
  width: 55px;
  height: 284px;
  top: 391px;
  left: 664px;
  img{
    width: 100%;
    height: 100%;
  }

}

.treasure-05{
  /* 设置背景图 */
  position: absolute;
  width: 55px;
  height: 463px;
  top: 706px;
  left: 131px;
  img{
    width: 100%;
    height: 100%;
  }
}
.treasure-06{
  /* 设置背景图 */
  position: absolute;
  width: 55px;
  height: 388px;
  top: 870px;
  left: 447px;
    img{
    width: 100%;
    height: 100%;
  }

}
.treasure-07{
  /* 设置背景图 */
  position: absolute;
  width: 55px;
  height: 284px;
  top: 648px;
  left: 546px;
  img{
    width: 100%;
    height: 100%;
  }
}
.right_arrow{
  position: absolute;
  width: 108px;
  height: 72px;
  top: 95%;
  left: 90%;
  transform: translate(-50%, -50%);
  img{
    width: 100%;
    height: 100%;
  }
}
    
/* 定义从上滑入的动画 */
.slide-down-enter-active, .slide-down-leave-active {
  transition: all 0.5s ease;
}
.slide-down-enter-from, .slide-down-leave-to {
  opacity: 0;
  transform: translateY(-50px); /* 从上方50px处滑入 */
}
</style>
